import { cn } from "../../classNames-DkX30VJU.js";
import { Tooltip } from "../../utils-CLNKe1ar.js";
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
// src/components/Truncated.tsx
const OFFSET_TOLERANCE = 2;
/**
* Whether the text is cut off, on either axis.
*
* - Horizontal covers text that cannot wrap (inherited `white-space: nowrap`).
* - The tolerance absorbs subpixel rounding on text that fits exactly.
*/
const hasTruncationOverflow = (m) => m.scrollHeight - OFFSET_TOLERANCE >= m.clientHeight || m.scrollWidth - OFFSET_TOLERANCE >= m.clientWidth;
const Truncated = ({ ref, text, tooltip = text, className, twoLines = false, noTooltip = false, tooltipVariant = "explanatory", tooltipPlacement = "top", ...rest }) => {
	const tooltipText = typeof tooltip === "string" ? tooltip : "";
	const [showTooltip, setShowTooltip] = useState(false);
	const truncatedClasses = cn(className, "tw:[word-break:break-all] tw:text-ellipsis", twoLines ? "tw:line-clamp-2 tw:[word-break:break-word]" : "tw:line-clamp-1");
	if (noTooltip || !tooltipText) return /* @__PURE__ */ jsx("span", {
		ref,
		className: truncatedClasses,
		...rest,
		children: text
	});
	return /* @__PURE__ */ jsx(Tooltip, {
		placement: tooltipPlacement,
		variant: tooltipVariant,
		forceHide: !showTooltip,
		tooltip: /* @__PURE__ */ jsx("div", { children: tooltipText }),
		triggerAsChild: true,
		children: /* @__PURE__ */ jsx("span", {
			ref,
			className: truncatedClasses,
			...rest,
			onMouseOver: (e) => {
				setShowTooltip(hasTruncationOverflow(e.currentTarget));
				rest.onMouseOver?.(e);
			},
			onFocus: (e) => {
				setShowTooltip(hasTruncationOverflow(e.currentTarget));
				rest.onFocus?.(e);
			},
			children: text
		})
	});
};
export { Truncated, hasTruncationOverflow };

//# sourceMappingURL=Truncated.js.map